import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllUsers, deleteUser } from "../../server/rolesAllApi";
import axios from "axios";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
 
const UnitPage = () => {
  const [chapters, setChapters] = useState([]);
  const [units, setUnits] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
 
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);
 
  useEffect(() => {
    if (token) {
      fetchUnits();
      fetchdepartment();
    }
  }, [
    token,
    currentPage,
    itemsPerPage,
    searchTerm,
    selectedDepartment,
    selectedCourseCategory,
    selectedCourse,
    selectedChapter,
  ]);
 
  useEffect(() => {
    fetchLevels();
  }, [selectedDepartment, selectedCourseCategory]);
 
  useEffect(() => {
    fetchCourse();
  }, [selectedDepartment, selectedCourseCategory, selectedCourse]);
 
  useEffect(() => {
    fetchChapters();
  }, [
    selectedDepartment,
    selectedCourseCategory,
    selectedCourse,
    selectedChapter,
  ]);
 
  const handleEditIndex = async (id, indexVal) => {
    try {
      if (indexVal !== null && indexVal !== "") {
        const response = await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/unit/index/${id}`,
          {
            position: indexVal,
          },
          {
            headers: {
              // "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token_key"),
            },
          }
        );
      }

      setUnits((prevPdfs) =>
        prevPdfs.map((pdf) =>
          pdf._id === id ? { ...pdf, position: indexVal } : pdf
        )
      );
      // Optionally, handle success message or any additional actions here
      // // console.log("Data saved successfully:", response.data);
    } catch (err) {
      // Handle error state
      console.error(err.message || "Failed to upload file");
    } finally {
      // setGalleryLoading(false); // End loading state regardless of success or failure
    }
  };
  const fetchUnits = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
 
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-units-with-pagination?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&department=${selectedDepartment}&level=${selectedCourseCategory}&course=${selectedCourse}&chapter=${selectedChapter}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      // setChapters(response.data.data); // Assuming your API structure is similar
      // setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      // console.log("Response received:", response);
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setUnits(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch chapters:", error);
      setError("Failed to fetch chapters.");
    } finally {
      setLoading(false);
    }
  };
 
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
 
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
 
  const handleEditUnit = (unit) => {
    // console.log("Unit data: ", unit);
    navigate(`/edit-unit/${unit._id}`, { state: { unit } });
  };
 
  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };
 
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
 
  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeleteUnit(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };
 
  const handleDeleteUnit = async (unit) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-unit/${unit._id}`,
        { isDeleted: true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();
 
        fetchUnits();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };
 
  const handleViewUnit = (unit) => {
    // console.log("Unit data: ", unit);
    navigate(`/unit-view/${unit._id}`, { state: { unit } });
  };
 
  const fetchdepartment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };
 
  const fetchLevels = async () => {
    // Check if selectedDepartment is available before making the request
    if (!selectedDepartment) {
      // console.log("Department not selected.");
      return;
    }
 
    // Ensure we have a valid token
    if (!token) {
      // console.log("Access required: No token provided.");
      return;
    }
 
    try {
      // Fetch course categories
      const courseCategoriesResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      // Handle the course categories data
      const courseCategoriesData = courseCategoriesResponse.data?.data;
      if (courseCategoriesData) {
        setCourseCategories(courseCategoriesData);
        // console.log(
        //   "Course categories fetched successfully:",
        //   courseCategoriesData
        // );
      } else {
        // console.log("No course categories found.");
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    }
  };
 
  const fetchCourse = async () => {
    // Check if selectedDepartment is available before making the request
    if (!selectedDepartment && !selectedCourseCategory) {
      // console.log("Department and level not selected.");
      return;
    }
 
    try {
      // Fetch course categories
      const courseResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${selectedDepartment}/${selectedCourseCategory}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      // Handle the course categories data
      const courseData = courseResponse.data?.data;
      if (courseData) {
        setCourses(courseData);
        // console.log("courseData fetched successfully:", courseData);
      } else {
        // console.log("No courseData found.");
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    }
  };
 
  const fetchChapters = async () => {
    // Check if selectedDepartment is available before making the request
    if (!selectedDepartment && !selectedCourseCategory && !selectedCourse) {
      // console.log("Department, level and course not selected.");
      return;
    }
 
    try {
      // Fetch course categories
      const chapterResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chapters/${selectedDepartment}/${selectedCourseCategory}/${selectedCourse}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      // Handle the course categories data
      const chapterData = chapterResponse.data?.data;
      if (chapterData) {
        setChapters(chapterData);
        // console.log("chapterData fetched successfully:", chapterData);
      } else {
        // console.log("No chapterData found.");
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    }
  };
 
  const handleToggleStatus = async (item) => {
    try {
      const updatedStatus = !item.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/unit-status-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
 
      if (response.status === 200) {
        // Update the status locally
        fetchUnits((prevcourse) =>
          prevcourse.map((b) =>
            b._id === item._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };
 
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
 
  return (
    <div className="card h-100 p-0 radius-12">
      {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
 
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={selectedDepartment}
            onChange={(e) => {
              setSelectedDepartment(e.target.value);
              setSelectedCourseCategory(""); // Reset course category
              setSelectedCourse(""); // Reset course
              setSelectedChapter(""); // Reset chapter
            }}
          >
            <option value="">Select Departments</option>
            {departments.map((department) => (
              <option key={department._id} value={department._id}>
                {department.department_name}
              </option>
            ))}
          </select>
 
          {selectedDepartment && (
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={selectedCourseCategory}
              onChange={(e) => {
                setSelectedCourseCategory(e.target.value);
                setSelectedCourse(""); // Reset course
                setSelectedChapter("");
              }}
            >
              <option value="">Select Level</option>
              {courseCategories.length > 0 ? (
                courseCategories.map((level) => (
                  <option key={level?._id} value={level?._id}>
                    {level?.courseCategoryName}
                  </option>
                ))
              ) : (
                <p>No Options</p>
              )}
            </select>
          )}
 
          {selectedDepartment && selectedCourseCategory && (
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={selectedCourse}
              onChange={(e) => {
                setSelectedCourse(e.target.value);
                setSelectedChapter("");
              }}
            >
              <option value="">Select Course</option>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <option key={course?._id} value={course?._id}>
                    {course?.coursename}
                  </option>
                ))
              ) : (
                <p>No Options</p>
              )}
            </select>
          )}
 
          {selectedDepartment && selectedCourseCategory && selectedCourse && (
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={selectedChapter}
              onChange={(e) => setSelectedChapter(e.target.value)}
            >
              <option value="">Select Chapter</option>
              {chapters.length > 0 ? (
                chapters.map((chapter) => (
                  <option key={chapter?._id} value={chapter?._id}>
                    {chapter?.chaptername}
                  </option>
                ))
              ) : (
                <p>No Options</p>
              )}
            </select>
          )}
        </div>
        <Link
          to="/add-unit"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New
        </Link>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">S.L</div>
                </th>
                <th scope="col">Department</th>
                <th scope="col">Level</th>
                <th scope="col">Position</th>
                <th scope="col">Course</th>
                <th scope="col">Chapter</th>
                <th scope="col">Unit</th>
                <th scope="col">Created At</th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {units.length > 0 ? (
                units.map((unit, index) => (
                  <tr key={unit._id}>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {unit.serial}
                      </div>
                    </td>
                    <td>{unit?.department?.department_name}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {unit?.level?.courseCategoryName}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <input
                        type="number"
                        id="position"
                        placeholder="Position"
                        className="form-control radius-8"
                        value={unit?.position}
                        onChange={(e) =>
                          handleEditIndex(unit._id, e.target.value)
                        }
                        required
                        style={{ width: "118px" }}
                      />
                    </td>
                    <td style={{ width: "369px", wordWrap: "break-word", whiteSpace: "normal" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {unit?.courses?.coursename}
                      </span>
                    </td>
                    <td style={{ width: "369px", wordWrap: "break-word", whiteSpace: "normal" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {unit?.chapters?.chaptername}
                      </span>
                    </td>
                    <td style={{ width: "369px", wordWrap: "break-word", whiteSpace: "normal" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {unit?.unitname}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                      {new Date(
                          unit.createdAt
                        ).toLocaleDateString()}{" "}
                        {new Date(
                          unit.createdAt
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </td>
 
                    <td className="text-center">
                      <button
                        onClick={() => handleToggleStatus(unit)}
                        className={`bg-${
                          unit.status ? "success" : "danger"
                        }-focus text-${
                          unit.status ? "success" : "danger"
                        }-600 border border-${
                          unit.status ? "success" : "danger"
                        }-main px-24 py-4 radius-4 fw-medium text-sm`}
                        style={{ cursor: "pointer" }}
                      >
                        {unit.status ? "Active" : "Inactive"}
                      </button>
                    </td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        <button
                          type="button"
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleViewUnit(unit)}
                        >
                          <Icon
                            icon="majesticons:eye-line"
                            className="icon text-xl"
                          />
                        </button>
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleEditUnit(unit)}
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                        {/* for deletion */}
                        <button
                          type="button"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteClick(unit)}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No unit found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
          Showing{" "}
    {units.length === 0 
      ? "0" 
      : `${(currentPage - 1) * itemsPerPage + 1}`}{" "} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>
 
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>
 
            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>
 
            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
 
        {/* for deletion */}
        <Modal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                Are you sure you want to delete this unit?
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseDeleteModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDelete}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};
 
export default UnitPage;
 
 